<template>
  <div class="lib__advertising lib__advertising--primary lib__advertising--lg lib__advertising--w-illu">
    <div class="lib__advertising__content">
      <h3 class="lib__advertising__title" v-html="$t('simulatorAdvertising.title')"></h3>
      <div class="lib__advertising__cta">
        <a :href="$t('simulatorAdvertising.link').toString()" target="_blank"
          class="lib__btn lib__btn--dark lib__btn--outline lib__btn--rounded">
          <span>{{ $t('simulatorAdvertising.button') }}</span>
          <i class="fas fa-chevron-right"></i>
        </a>
      </div>
    </div>
    <div class="lib__advertising__illu">
      <img src="@ores/css-library/assets/img/advertising/house@2x.jpg" alt="">
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'simulator-advertising'
})
export default class SimulatorAdvertising extends Vue { }
</script>